import CreateItemButton from "components/buttons/create";
import List from "components/list";
import HeaderPortal from "components/portal/header-portal";
import { PermissionControlledInput } from "permissions/components/input";
import { WebsiteLink } from "./components/website-link";
import { EmailLink } from "./components/email-link";

export default function Companies() {

  const columns = [
    {
      id: "name",
      header: "Company Name",
      accessorKey: "name",
      sortable: true,
    },
    {
      id: "state",
      header: "State",
      accessorKey: "state",
      cell: (info) => {
        const state = info.row.original.state;
        return (
          <span className="text-foreground">{state}</span>
        );
      },
    },
    {
      id: "country_id.name",
      header: "Country",
      accessorKey: "country_id.name",
      cell: (info) => {
        const country = info.row.original.country_id?.name;
        return (
          <span className="text-foreground">{country}</span>
        );
      },
    },
    {
      id: "phone",
      header: "Contact No.",
      accessorKey: "phone",
      cell: (info) => {
        const mobile_number = info.row.original.phone;
        return (
          <span className="text-foreground">{mobile_number}</span>
        );
      },
    },
    {
      id: "email",
      header: "Email",
      accessorKey: "email",
      cell: EmailLink,
    },
    {
      id: "website",
      header: "Website",
      accessorKey: "website",
      cell: WebsiteLink,
    },
  ];

  const fields = [
    "id",
    "name",
    "website",
    "email",
    "address_line_1",
    "address_line_2",
    "phone",
    "city",
    "state",
    "zipcode",
    "country_id.name",
  ];

  return (
    <div className="w-full">
      <HeaderPortal>
        <PermissionControlledInput
          rule={"create:*"}
          collection="companies"
          showWhenDisabled={false}
        >
          <CreateItemButton href>Company</CreateItemButton>
        </PermissionControlledInput>
      </HeaderPortal>
      <div className="flex-1 h-full">
        <List
          title="Companies"
          endPoint="companies"
          columns={columns}
          meta={{
            fields,
          }}
          href={(item) => item.id}
          rowClassName="h-13"
        />
      </div>
    </div>
  );
}
